import { useCallback, useMemo } from 'react';
import Toast from 'react-native-toast-message';

export interface ToastOptions {
  type?: 'success' | 'error' | 'info';
  title?: string; // For compatibility with existing code
  description?: string; // For compatibility with existing code
  variant?: 'destructive'; // For compatibility with existing code
  text1?: string;
  text2?: string;
  position?: 'top' | 'bottom';
  visibilityTime?: number;
}

export function useToast() {
  const show = useCallback((options: ToastOptions) => {
    const type = options.variant === 'destructive' ? 'error' : (options.type || 'info');
    const text1 = options.title || options.text1 || '';
    const text2 = options.description || options.text2;

    const toastParams: any = {
      type,
      text1,
      position: options.position || 'top',
      visibilityTime: options.visibilityTime || 4000,
    };

    if (text2) {
      toastParams.text2 = text2;
    }

    Toast.show(toastParams);
  }, []);

  return useMemo(() => ({ show, toast: { show } }), [show]);
}